import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class VersionCheckService {
  // this will be replaced by actual hash post-build.js
  private currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';
  private lastCheckedTs = (new Date()).getTime();

  constructor(private http: HttpClient) {
  }

  /**
   * Checks in every set frequency the version of frontend application
   * @param url
   * @param {number} frequency - in milliseconds, defaults to 30 minutes
   */
  public initVersionCheck(url, frequency = 1000 * 60 * 30) {
    this.checkVersion(url);
    this.lastCheckedTs = (new Date()).getTime();
    setInterval((): void => {
      this.checkVersion(url);
    }, frequency);
  }

  /**
   * Will do the call and check if the hash has changed or not
   * @param url
   */
  private checkVersion(url) {
    // console.log('checking version', url);
    // timestamp these requests to invalidate caches
    if ((new Date()).getTime() - this.lastCheckedTs < 5 * 60 * 1000) {
      // wait for minimum 5 minutes for version match checking
      return;
    }
    this.lastCheckedTs = (new Date()).getTime();
    this.http.get(url + '?t=' + new Date().getTime())
      .subscribe(
        (response: any) => {
          const hash = response.hash;
          const hashChanged = this.hasHashChanged(this.currentHash, hash);

          // If new version, do something
          if (hashChanged) {
            if (confirm('A new version of this app is available. Do you want to reload?')) {
              location.reload();
              // store the new hash so we wouldn't trigger versionChange again
              // only necessary in case you did not force refresh
              this.currentHash = hash;
            }
          }
        },
        (err) => {
          console.error(err, 'Could not get version');
        }
      );
  }

  /**
   * Checks if hash has changed.
   * This file has the JS hash, if it is a different one than in the version.json
   * we are dealing with version change
   * @param currentHash
   * @param newHash
   * @returns {boolean}
   */
  private hasHashChanged(currentHash, newHash) {
    if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
      return false;
    }

    return currentHash !== newHash;
  }
}
